<template src="./html/Reports.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import FileSaver from 'file-saver'
	//--
	import FilterCustomers from './../views/customers/Filter'
	import DatatableCustomers from './../views/customers/Datatable'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'filter-customers': FilterCustomers,
			'datatable-customers': DatatableCustomers,
		},
		data () {
			return {
				visible: null
			}
		},
		methods: {
			setFilter(type, filter) {
				if(type == 'customers') {
					if(this.visible == 'customers') {
						this.visible = type
						this.$refs.DatatableCustomers.setFilter(filter)
						this.$refs.DatatableCustomers.reload()
					} else {
						this.$refs.DatatableCustomers.setFilter(filter)
						this.visible = type
					}
				}
			},

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/reports/layout/Reports.vue